export default [
  {
    path: '/clientes-dkp',
    name: 'clientes-dkṕ-list',
    component: () => import('@/views/clientes-dkp/cliente/list/Index.vue'),
    meta: {
      pageTitle: 'Clientes DKP',
      actions: 'manage',
      resource: 'all',
    },
  },
];
